import {
    ChoiceGroup,
    IChoiceGroupOption,
    IChoiceGroupProps,
} from 'office-ui-fabric-react/lib/ChoiceGroup';
import * as React from 'react';
import { observer } from 'mobx-react';
import { Image } from 'office-ui-fabric-react/lib/Image';
import { resolve as urlResolve } from 'url';
import getPackageBaseUrl from 'owa-session-store/lib/actions/getPackageBaseUrl';

const classnames = require('classnames');
const styles = require('./ChoiceGroupWithImages.scss');

export interface ChoiceOptionWithImage extends IChoiceGroupOption {
    imageUri: string;
    width: number;
}

export interface ChoiceGroupWithImagesProps extends IChoiceGroupProps {
    options?: ChoiceOptionWithImage[];
}

const ChoiceItemWithImages = observer((props: IChoiceGroupOption) => {
    let option = props as ChoiceOptionWithImage;

    return (
        <div className={styles.option} style={{ width: `${option.width + 4}px` }}>
            <span id={props.labelId} className="ms-ChoiceFieldLabel">
                {props.text}
            </span>
            <div
                className={classnames(
                    styles.imageContainer,
                    'flipForRtl',
                    option.checked && styles.selected
                )}>
                <Image
                    src={urlResolve(getPackageBaseUrl(), option.imageUri)}
                    className={styles.image}
                    alt=""
                    role="presentation"
                />
            </div>
        </div>
    );
});

@observer
export default class ChoiceGroupWithImages extends React.Component<ChoiceGroupWithImagesProps, {}> {
    render() {
        return (
            <ChoiceGroup
                {...this.props}
                className={classnames(this.props.className, styles.choiceGroup)}
                options={
                    this.props.options &&
                    this.props.options.map(
                        option =>
                            ({
                                ...option,
                                ...{ onRenderLabel: this.onRenderChoice },
                            } as IChoiceGroupOption)
                    )
                }
            />
        );
    }

    private onRenderChoice = (props: IChoiceGroupOption) => <ChoiceItemWithImages {...props} />;
}
